import React, { Component } from 'react'
import { connect } from 'react-redux'
import './assets/styles.css'
import './assets/normalize.css'
import './assets/skeleton.css'
import {Route, BrowserRouter, Redirect, Switch} from 'react-router-dom'
import { userListener } from '../actions/userActions'
import Transactions from './Transactions'
import Login from './Login'
import Header from './Header'
import Edit from './Edit';
import New from './New';

function PrivateRoute({
  component: Component,
  authed,
  ...rest
}) {
  return (
    <Route {...rest} render={(props) => authed === true
      ? <Component {...props}/>
      : <Redirect to={{
        pathname: '/',
        state: {
          from: props.location
        }
      }}/>}/>
  )
}

@connect((store)=>{
  return {
    userData: store.user.userData,
    auth: store.user.auth,
    selectedCompany: store.user.selectedCompany,
    userCompanies: store.user.userCompanies
  } 
})
class App extends Component {

  componentWillMount(){
    this.props.dispatch(userListener())    
  }

  render() {
    
    return (
      <BrowserRouter>
        <div>
          <Header/>
          <div className="container">
            <Switch>
              <Route path='/' exact component={Login}/>
              <PrivateRoute authed={this.props.auth} path='/transactions/edit/:id' component={Edit} />
              <PrivateRoute authed={this.props.auth} path='/transactions/duplicate/:id' component={Edit} />
              <PrivateRoute authed={this.props.auth} path='/transactions/new' component={New} />
              <PrivateRoute authed={this.props.auth} path='/transactions' component={Transactions} />
              <Route render={() => <h3>No Match</h3>}/>
            </Switch>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js